<template>
  <c-row>
    <c-col col="12">
      <c-card>
        <c-card-header>
          <c-icon name="cil-justify-center" />
          <strong>Bootstrap button group</strong>
          <div class="card-header-actions">
            <a
              href="https://coreui.io/vue/docs/components/button-components"
              class="card-header-action"
              rel="noreferrer noopener"
              target="_blank"
            >
              <small class="text-muted">docs</small>
            </a>
          </div>
        </c-card-header>
        <c-card-body>
          <div>
            <c-button-group>
              <c-button color="secondary">One</c-button>
              <c-button color="secondary">Two</c-button>
              <c-button color="secondary">Three</c-button>
              <c-button color="secondary">Four</c-button>
              <c-button color="secondary" class="d-sm-down-none">Five</c-button>
            </c-button-group>
            <br />
            <br />
            <c-button-group>
              <c-button class="d-sm-down-none" color="success">Success</c-button>
              <c-button color="info">Info</c-button>
              <c-button color="warning">Warn</c-button>
              <c-button class="d-sm-down-none" color="primary">Primary</c-button>
              <c-button color="danger">Danger</c-button>
              <c-button color="link">Link</c-button>
            </c-button-group>
          </div>
        </c-card-body>
      </c-card>
    </c-col>
    <c-col col="12">
      <c-card>
        <c-card-header>
          <c-icon name="cil-justify-center" />
          <strong>Button group</strong>
          sizing
        </c-card-header>
        <c-card-body>
          <div>
            <c-button-group>
              <c-button color="secondary">Left</c-button>
              <c-button color="secondary">Middle</c-button>
              <c-button color="secondary">Right</c-button>
            </c-button-group>
            <br />
            <br />
            <c-button-group size="sm">
              <c-button color="secondary">Left</c-button>
              <c-button color="secondary">Middle</c-button>
              <c-button color="secondary">Right</c-button>
            </c-button-group>
            <br />
            <br />
            <c-button-group size="lg">
              <c-button color="secondary">Left</c-button>
              <c-button color="secondary">Middle</c-button>
              <c-button color="secondary">Right</c-button>
            </c-button-group>
          </div>
        </c-card-body>
      </c-card>
    </c-col>
    <c-col col="12">
      <c-card>
        <c-card-header>
          <c-icon name="cil-justify-center" />
          <strong>Button group</strong>
          dropdown support
        </c-card-header>
        <c-card-body>
          <div>
            <c-button-group>
              <c-button color="secondary" class="d-sm-down-none">Button 1</c-button>
              <c-button color="secondary" class="d-sm-down-none">Button 2</c-button>
              <c-dropdown right text="Menu" color="success">
                <c-dropdown-item>Item 1</c-dropdown-item>
                <c-dropdown-item>Item 2</c-dropdown-item>
                <c-dropdown-divider />
                <c-dropdown-item>Item 3</c-dropdown-item>
              </c-dropdown>
              <c-button color="secondary" class="d-sm-down-none">Button 3</c-button>
              <c-dropdown right split text="Split Menu" color="info">
                <c-dropdown-item>Item 1</c-dropdown-item>
                <c-dropdown-item>Item 2</c-dropdown-item>
                <c-dropdown-divider />
                <c-dropdown-item>Item 3</c-dropdown-item>
              </c-dropdown>
            </c-button-group>
          </div>
        </c-card-body>
      </c-card>
    </c-col>
    <c-col col="12">
      <c-card>
        <c-card-header>
          <c-icon name="cil-justify-center" />
          <strong>Button group</strong>
          vertical variation
        </c-card-header>
        <c-card-body>
          <div>
            <c-button-group vertical>
              <c-button color="secondary">Top</c-button>
              <c-button color="secondary">Middle</c-button>
              <c-button color="secondary">Bottom</c-button>
            </c-button-group>
          </div>
        </c-card-body>
      </c-card>
    </c-col>
    <c-col col="12">
      <c-card>
        <c-card-header>
          <c-icon name="cil-justify-center" />
          <strong>Button toolbar</strong>
          <small>with button groups</small>
        </c-card-header>
        <c-card-body>
          <c-button-toolbar aria-label="Toolbar with button groups">
            <c-button-group class="mx-1">
              <c-button color="secondary" class="d-sm-down-none">&laquo;</c-button>
              <c-button color="secondary">&lsaquo;</c-button>
            </c-button-group>
            <c-button-group class="mx-1">
              <c-button color="secondary" class="d-sm-down-none">Edit</c-button>
              <c-button color="secondary">Undo</c-button>
              <c-button color="secondary">Redo</c-button>
            </c-button-group>
            <c-button-group class="mx-1">
              <c-button color="secondary">&rsaquo;</c-button>
              <c-button color="secondary" class="d-sm-down-none">&raquo;</c-button>
            </c-button-group>
          </c-button-toolbar>
          <hr class="d-sm-down-none" />
          <c-button-toolbar aria-label="Toolbar with button groups and input groups" class="d-sm-down-none">
            <c-button-group size="sm" class="mx-1">
              <c-button color="secondary">New</c-button>
              <c-button color="secondary">Edit</c-button>
            </c-button-group>
            <c-input class="mb-0 w-25 mx-1" size="sm" append=".00" value="100" prepend="$" />
            <c-select
              class="mb-0 w-25 mx-1"
              size="sm"
              value="Medium"
              :options="['Large', 'Medium', 'Small']"
              custom
              prepend="Size"
            />
            <c-button-group size="sm" class="mx-1">
              <c-button color="secondary">Save</c-button>
              <c-button color="secondary">Cancel</c-button>
            </c-button-group>
          </c-button-toolbar>
          <hr />
          <c-button-toolbar aria-label="Toolbar with button groups and dropdown menu">
            <c-button-group class="mx-1 d-sm-down-none">
              <c-button color="secondary">New</c-button>
              <c-button color="secondary">Edit</c-button>
              <c-button color="secondary">Undo</c-button>
            </c-button-group>
            <c-dropdown color="secondary" class="mx-1" placement="bottom-end" button-content="Menu">
              <c-dropdown-item>Item 1</c-dropdown-item>
              <c-dropdown-item>Item 2</c-dropdown-item>
              <c-dropdown-item>Item 3</c-dropdown-item>
            </c-dropdown>
            <c-button-group class="mx-1">
              <c-button color="secondary">Save</c-button>
              <c-button color="secondary">Cancel</c-button>
            </c-button-group>
          </c-button-toolbar>
        </c-card-body>
      </c-card>
    </c-col>
  </c-row>
</template>
<script>
export default {
  name: 'ButtonGroups',
};
</script>
